import { COLOR_BG, COLOR_GRAY_BORDER, COLOR_ACCENT, COLOR_ACCENT_LIGHT, COLOR_BG_Black  } from '../colors.constants';

export const colorsButton = {
  colorButtonBorderDisabled: COLOR_GRAY_BORDER,

  // contained button theme
  colorButtonContainedBackground: COLOR_ACCENT,
  colorButtonContainedColor: COLOR_BG_Black,
  colorButtonContainedColorHover: COLOR_BG,
  colorButtonContainedBorder: `1px solid ${COLOR_ACCENT}`,
  colorButtonContainedBorderHover: `1px solid ${COLOR_ACCENT_LIGHT}`,
  colorButtonContainedBackgroundHover: COLOR_ACCENT_LIGHT,

  // outlined button theme
  colorButtonOutlinedBackground: 'transparent',
  colorButtonOutlinedColor: COLOR_ACCENT,
  colorButtonOutlinedColorHover: COLOR_BG_Black,
  colorButtonOutlinedBorder: `1px solid ${COLOR_ACCENT}`,
  colorButtonOutlinedBorderHover: `1px solid ${COLOR_ACCENT}`,
  colorButtonOutlinedBackgroundHover: COLOR_ACCENT,
};
